<template>
  <IQOS :title="'Вартість доставки'">
    <div class="partner-conditions tenshi" v-if="type == 'tenshi'">
      <p class="c-grey">
        Для Вашого закладу працює індивідуальний тариф доставки:
      </p>
      <p>
          При замовленню в межах міста Ужгород - доставка безкоштовна
      </p>
      <p class="mb-0">
          При замовленні поза межами міста Ужгород - доставка по тарифу служби доставки. (платить клієнт)
      </p>
    </div>
    <div class="partner-conditions teritoria" v-if="type == 'teritoria'">
      <p class="c-grey">
        Для Вашого закладу працює індивідуальний тариф доставки:
      </p>
      <p>
          При замовленню на суму від 200 грн - доставка безкоштовна.
      </p>
      <p class="mb-0">
          При замовленню на суму до 200 грн - доставка коштує 35 грн.
      </p>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

export default {
  components: {
    IQOS
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  },
  props: {
    type: String
  }
};
</script>

<style scoped>
.partner-conditions {
  color: #ededed;
  margin-top: 0;
}

.partner-price {
  border-radius: 1vw;
  border: 1px solid #ededed;
  padding: 0.2vw 0.7vh;
  display: inline-block;
}
</style>